module.exports = __webpack_public_path__ + "static/media/memory.94bea1a9.svg";